export class Scalar {
    static WithinEpsilon(a, b, epsilon = Scalar.EPSILON) {
        const num = a - b;
        return -epsilon <= num && num <= epsilon;
    }
    static Sign(value) {
        return value > 0 ? 1 : -1;
    }
    static Clamp(value, min, max) {
        if (min === void 0) {
            min = 0;
        }
        if (max === void 0) {
            max = 1;
        }
        return Math.min(max, Math.max(min, value));
    }
    static GetRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    static ToHex(i) {
        const str = i.toString(16);
        if (i <= 15) {
            return ("0" + str).toUpperCase();
        }
        return str.toUpperCase();
    }
}
Scalar.EPSILON = 1.401298e-45;
Scalar.DEG2RAD = Math.PI / 180;
Scalar.RAD2DEG = 180 / Math.PI;
Scalar.INCH2METER = 0.0254;
Scalar.METER2INCH = 39.3701;
Scalar.PI = Math.PI;
Scalar.PI_2 = Math.PI / 2;
Scalar.PI_4 = Math.PI / 4;
export class AbstractRange {
    constructor(min, max) {
        this._min = min;
        this._max = max;
    }
    get min() {
        return this._min;
    }
    set min(m) {
        this._min = m;
        this._d = undefined;
    }
    get max() {
        return this._max;
    }
    set max(m) {
        this._max = m;
        this._d = undefined;
    }
    get delta() {
        if (this._d === undefined) {
            this._d = this.computeDelta(this._min, this._max);
        }
        return this._d;
    }
}
export class Range extends AbstractRange {
    static Zero() {
        return new Range(0, 0);
    }
    static Max() {
        return new Range(Number.MIN_VALUE, Number.MAX_VALUE);
    }
    computeDelta(a, b) {
        return a && b ? b - a : Number.POSITIVE_INFINITY;
    }
    constructor(min, max) {
        super(min, max);
    }
    unionInPlace(min, max) {
        if (min instanceof Range) {
            this.unionInPlace(min.min, min.max);
            return;
        }
        this._min = Math.min(this._min, min);
        if (max !== undefined) {
            this._max = Math.max(this._max ?? max, max);
        }
    }
    clone() {
        return new Range(this._min, this._max);
    }
}
//# sourceMappingURL=math.js.map